import React from "react";
import { VStack, Text, StackProps } from "@chakra-ui/react";

type WithPageIntroProps = StackProps & {
  children: React.ReactNode;
  spacing?: StackProps["spaceY"];
};

export default function WithPageIntro({
  children,
  spacing = "3",
  ...rest
}: WithPageIntroProps) {
  const renderChild = (child: React.ReactNode, i: number) => {
    if (typeof child === "string" || typeof child === "number") {
      return <Text key={i}>{child}</Text>;
    }
    return child;
  };

  return (
    <VStack
      align="stretch"
      spaceY={spacing}
      mt="4"
      color="moveon.publicFont"
      fontSize={{ base: "sm", md: "md" }}
      lineHeight="tall"
      {...rest}
    >
      {React.Children.map(children, renderChild)}
    </VStack>
  );
}
